import { Tabs, SurfaceCard, PageContainer } from '@react-apps/design-system';
import { useRouteTabs } from '@/shared/hooks/use-route-tabs';
import { ContentItemsPanel } from '../components/ContentItemsPanel';
import { ExamsPanel } from '../components/ExamsPanel';
import { InstitutionsPanel } from '../components/InstitutionsPanel';
import { SubjectsPanel } from '../components/SubjectsPanel';
import { SubjectViewsPanel } from '../components/SubjectViewsPanel';
import { SubjectEdgesPanel } from '../components/SubjectEdgesPanel';

/**
 * Hub do módulo Conteúdo: uma aba por área (Conteúdos, Provas, Instituições,
 * Assuntos, Visões, Grafo). Cada aba é um painel autocontido com sua própria
 * listagem + ações. Espelha o `CatalogPage`. Consome `/admin/content/*` do
 * monolith.
 *
 * "Instituições" fica ao lado de "Provas" porque é dela que a prova depende: a
 * sigla cadastrada aqui é o que a planilha de importação tem de dizer, e o erro
 * `NOT_FOUND` da importação faz deep link para cá.
 */
const TAB_IDS = [
  'items',
  'exams',
  'institutions',
  'subjects',
  'views',
  'edges',
];

export function ContentPage() {
  const { activeTab, onTabChange } = useRouteTabs('/content', TAB_IDS);

  return (
    <PageContainer maxWidth="6xl">
      <div>
        <h1 className="text-(--color-text-primary) text-2xl font-semibold">
          Conteúdo
        </h1>
        <p className="text-(--color-text-secondary) mt-1 text-sm">
          Gerencie conteúdos, provas, assuntos, visões e o grafo de
          classificação da plataforma.
        </p>
      </div>

      <SurfaceCard>
        {/* Aba ativa vem da URL (`/content/:tab`). */}
        <Tabs
          activeTab={activeTab}
          onTabChange={onTabChange}
          tabs={[
            { id: 'items', label: 'Conteúdos', content: <ContentItemsPanel /> },
            { id: 'exams', label: 'Provas', content: <ExamsPanel /> },
            {
              id: 'institutions',
              label: 'Instituições',
              content: <InstitutionsPanel />,
            },
            { id: 'subjects', label: 'Assuntos', content: <SubjectsPanel /> },
            { id: 'views', label: 'Visões', content: <SubjectViewsPanel /> },
            { id: 'edges', label: 'Grafo', content: <SubjectEdgesPanel /> },
          ]}
        />
      </SurfaceCard>
    </PageContainer>
  );
}
